/**
 * useGroupActions Hook
 * 
 * Handles group operations: add, edit, delete, change icon/color
 */

import { GROUP_COLORS, GROUP_ICONS } from './constants/colors';

export const useGroupActions = (localSprint, setLocalSprint) => {

  const handleAddGroup = () => {
    const groupName = prompt('Enter group name:');
    if (!groupName) return;

    const randomColor = GROUP_COLORS[Math.floor(Math.random() * GROUP_COLORS.length)];
    const randomIcon = GROUP_ICONS[Math.floor(Math.random() * GROUP_ICONS.length)];

    setLocalSprint(prev => {
      if (!prev) return prev;
      
      const newGroup = {
        id: `group-${Date.now()}`,
        name: groupName,
        color: randomColor,
        icon: randomIcon,
        order: (prev.groups?.length || 0) + 1,
      };

      return { ...prev, groups: [...(prev.groups || []), newGroup] };
    });
  };

  const handleEditGroup = (group) => {
    const newName = prompt('Edit group name:', group.name);
    if (!newName || newName === group.name) return;
    
    setLocalSprint(prev => {
      if (!prev) return prev;
      const groups = prev.groups || [];
      return {
        ...prev,
        groups: groups.map(g => 
          g.id === group.id ? { ...g, name: newName } : g
        ),
      };
    });
  };

  const handleChangeGroupIcon = (groupId, icon) => {
    setLocalSprint(prev => {
      if (!prev) return prev;
      const groups = prev.groups || [];
      return {
        ...prev,
        groups: groups.map(g => 
          g.id === groupId ? { ...g, icon } : g
        ),
      };
    });
  };

  const handleChangeGroupColor = (groupId, color) => {
    setLocalSprint(prev => {
      if (!prev) return prev;
      const groups = prev.groups || [];
      return {
        ...prev,
        groups: groups.map(g => 
          g.id === groupId ? { ...g, color } : g
        ),
      };
    });
  };

  const handleDeleteGroup = (groupId) => {
    if (!window.confirm('Delete this group? Tasks will be moved to ungrouped.')) return;
    
    setLocalSprint(prev => {
      if (!prev) return prev;
      const groups = prev.groups || [];
      const tasks = prev.tasks || [];
      return {
        ...prev,
        groups: groups.filter(g => g.id !== groupId),
        tasks: tasks.map(t => 
          t.groupId === groupId ? { ...t, groupId: null } : t
        ),
      };
    });
  };

  return {
    handleAddGroup,
    handleEditGroup,
    handleChangeGroupIcon,
    handleChangeGroupColor,
    handleDeleteGroup,
  };
};

export default useGroupActions;

